// extracted by mini-css-extract-plugin
export default {"hidden":"Certificado_hidden__eE0Fx","form":"Certificado_form__cBW1N","content":"Certificado_content__-U0uC","link":"Certificado_link__8ojiy"};